var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"table",staticClass:"table"},[_c('div',{staticClass:"right"},_vm._l((_vm.rightColumn),function(item,index){return _c('div',{key:index,staticClass:"r-i",class:_vm.column[index].key},_vm._l((item),function(_item,_index){return _c('div',{key:_index,staticClass:"r-i-i row"},[_vm._v(_vm._s(_item))])}),0)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }